import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './feeds.jade'
import getState from '../../services/event-state'
import getStateOld from '../../services/create-event'
import notify from '@scoutgg/ftw/source/services/notification'
import { Match } from '../../models'
import { prompt } from '@scoutgg/ftw/source/services/modal'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class Feeds extends HTMLElement {
  toggleFeeds(match) {
    if(match.$isSubmitting) return
    if(match.stopFeeds) {
      prompt('As an admin type "UNLOCK" to unlock this match', { min: 1, max: 10 })
        .then(str => {
          match.post('start-feeds', { code: str })
            .then(() => this.render(match.stopFeeds = false))
        })
    } else {
      match.stopFeeds = true
      match.post('stop-feeds').then(() => {
        notify('Feeds stopped', { level: 'success', timeout: 5000 })
      })
    }
    this.render()
  }

  mergeFeeds(match) {
    if(match.$isSubmitting) return
    match.post('merge-locked').then(() => {
      getStateOld(match).reload(true)
      getState(match).reload()
      notify('Feeds used', { level: 'success', timeout: 5000 })
    }).catch(err => {
      notify(err.message, { level: 'danger', timeout: 10000 })
    })
  }
}
